import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";


const UnSubscribe= lazy(()=>import("src/pages/unSubscribe"));
const SelfUnSubscribe = lazy(() => import("src/pages/selfUnSubscribe"));
const UserDeletion = lazy(() => import("src/sections/dashboard/account/user-deletion"));

export const unSubscribe = [
  {
    path: "",
    element: (  
        <Suspense>    
          <Outlet />
        </Suspense>
    ),
    children: [
      {
        path: "unSubscribe",
        index: true,
        element: <UnSubscribe/>,
      },
      {
        path: "selfUnSubscribe",
        index: true,
        element: <SelfUnSubscribe/>,
      },
      {
        path: "user-deletion",
        index: true,
        element: <UserDeletion/>,
      },
      {
        path: "user-deletion-process",
        index: true,
        element: <UserDeletion/>,
      }
    ],
  },
];
